module.exports = __webpack_public_path__ + "static/media/filter.3b2cf0c2.svg";